'use client';

import Script from 'next/script';
import { FC, useEffect, useState } from 'react';

import { getSigninUrl } from 'src/authentication/components/SSO/ssoHelper';
import { COOKIE_USER_TOKEN } from 'src/constants/cookie.constants';

export const GoogleOneTap: FC = () => {
  const [loginUrl, setLoginUrl] = useState<string | null>(null);

  useEffect(() => {
    if (globalThis.window !== undefined) {
      const signinUrl = getSigninUrl(window.location.toString());
      const loginQueryParams = new URLSearchParams({
        state: btoa(signinUrl),
      });
      const loginUrlBase = new URL('/api/auth/google/one-tap', window.location.toString());
      const url = `${loginUrlBase}?${loginQueryParams.toString()}`;
      setLoginUrl(url);
    }
  }, []);

  return (
    <>
      <Script src="https://accounts.google.com/gsi/client" key="googleSso" strategy="afterInteractive" />
      {!!loginUrl && (
        <div
          id="g_id_onload"
          data-client_id={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}
          data-login_uri={loginUrl}
          data-itp_support="true"
          data-skip_prompt_cookie={COOKIE_USER_TOKEN}
        />
      )}
    </>
  );
};
